// extracted by mini-css-extract-plugin
module.exports = {"labelsNoData":"LabelsDetails_labelsNoData__mDSpH","contentContainer":"LabelsDetails_contentContainer__yL485","tasksNoDataTitle":"LabelsDetails_tasksNoDataTitle__3s8EX"};